import { render, staticRenderFns } from "./dr-file-input-component.vue?vue&type=template&id=04991d22"
import script from "./dr-file-input-component.vue?vue&type=script&lang=js"
export * from "./dr-file-input-component.vue?vue&type=script&lang=js"
import style0 from "./dr-file-input-component.vue?vue&type=style&index=0&id=04991d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports